import { render, staticRenderFns } from "./Taskranking.vue?vue&type=template&id=726690ef&"
import script from "./Taskranking.vue?vue&type=script&lang=js&"
export * from "./Taskranking.vue?vue&type=script&lang=js&"
import style0 from "./Taskranking.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports